// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2-zRQ","text":"SelectPayment_text__2xoXE","title":"SelectPayment_title__1eYKd","btn":"SelectPayment_btn__fuqy5"};